import React from 'react';

export const Switch = ({
    checked = false,
    onChange,
    disabled = false,
    id,
    className = '',
}) => {
    return (
        <button
            type="button"
            id={id}
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => !disabled && onChange?.(!checked)}
            className={`switch-toggle relative inline-flex h-7 w-[52px] flex-shrink-0 cursor-pointer items-center rounded-full border-none p-0.5 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-success/30 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
                checked ? 'bg-success' : 'bg-gray-200'
            } ${className}`}
        >
            <span
                aria-hidden="true"
                className={`pointer-events-none block h-6 w-6 rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out ${
                    checked ? 'translate-x-6' : 'translate-x-0'
                }`}
            />
        </button>
    );
};
